import { createStyles, makeStyles } from '@material-ui/core/styles';
import { GREEN, YELLOW, RED, GRAY } from 'constants/colors';
const size = 1;
export default makeStyles(theme => createStyles({
  statusBulletRoot: {
    display: 'flex',
    margin: theme.spacing(0.5, 0)
  },
  bullet: {
    display: 'flex',
    alignSelf: 'center',
    height: theme.spacing(size),
    width: theme.spacing(size),
    marginRight: theme.spacing(1.5),
    borderRadius: '50%'
  },
  bulletGreen: {
    background: GREEN
  },
  bulletYellow: {
    background: YELLOW
  },
  bulletGrey: {
    background: GRAY
  },
  bulletRed: {
    background: RED
  }
}));